import { isHeyaHost } from '@/app/theme/resolveTheme'
import { DOMAIN_COUNTRY_MAP } from '@/src/constants/domain'

export interface SupportContacts {
    local_calls: string
    international_calls: string
    whatsapp: string
    email: string
}

interface SupportConfig {
    brand: 'Flyin' | 'Cleartrip'
    domain: 'EG' | 'AE' | 'FSA' | 'FSA_HEYA'
    contacts: SupportContacts
}

const CUSTOMER_SUPPORT_DATA: SupportConfig[] = [
    {
        brand: 'Flyin',
        domain: 'EG',
        contacts: {
            local_calls: '0225873888',
            international_calls: '+20225873888',
            whatsapp: '+201033332689',
            email: 'customercare@flyin.com'
        }
    },
    {
        brand: 'Flyin',
        domain: 'AE',
        contacts: {
            local_calls: '+97148754550',
            international_calls: '+971525473527',
            whatsapp: '+971525473527',
            email: 'customercare@flyin.com'
        }
    },
    {
        brand: 'Cleartrip',
        domain: 'AE',
        contacts: {
            local_calls: '+97148754545',
            international_calls: '+97148754545',
            whatsapp: '+971502672234',
            email: 'customersupport@cleartrip.ae'
        }
    },
    {
        brand: 'Flyin',
        domain: 'FSA',
        contacts: {
            local_calls: '920025959',
            international_calls: '+966920025959',
            whatsapp: '+966920025959',
            email: 'customercare@flyin.com'
        }
    },
    {
        brand: 'Flyin',
        domain: 'FSA_HEYA',
        contacts: {
            local_calls: '920019162',
            international_calls: '+966920019162',
            whatsapp: '+966920019162',
            email: 'customercare@flyin.com'
        }
    }
]

export const getSupportContacts = (
    brandName: 'Flyin' | 'Cleartrip',
    origin?: string
): SupportContacts | undefined => {
    const rawDomainCode = DOMAIN_COUNTRY_MAP[origin || ''] || 'AE'
    const baseDomainCode =
        rawDomainCode === 'FEG' ? 'EG' : rawDomainCode === 'FAE' ? 'AE' : rawDomainCode
    // Heya shares the FSA domain key but has its own support number.
    const domainCode =
        baseDomainCode === 'FSA' && isHeyaHost((origin || '').replace(/^https?:\/\//, ''))
            ? 'FSA_HEYA'
            : baseDomainCode

    return (
        CUSTOMER_SUPPORT_DATA.find(item => item.brand === brandName && item.domain === domainCode) ||
        CUSTOMER_SUPPORT_DATA.find(item => item.brand === brandName)
    )?.contacts
}

